export default hasNamedImports;

function hasNamedImports(mod) {
	var i = mod.imports.length;

	while (i--) {
		if (mod.imports[i].isNamed) {
			return true;
		}
	}
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/utils/hasNamedImports.js.01-babel.map